"use strict";

import $ from 'jquery';

$(() => {
    $('.radio-btn-group input[checked]').each((i, el) => {
        $(el).parent().addClass('active');
    });
});
